export const variaveisDisponiveis = [
  { value: 'tmax', label: 'Temp. Máxima (°C)' },
  { value: 'tmean', label: 'Temp. Média (°C)' },
  { value: 'tmin', label: 'Temp. Mínima (°C)' },
  { value: 'ur', label: 'Umidade Relativa (%)' },
  { value: 'rg', label: 'Radiação Global (MJ/m²)' },
  { value: 'ws2m', label: 'Vento (m/s)' },
  { value: 'ppt', label: 'Precipitação (mm/dia)' },
  { value: 'eto_mm_day', label: 'ETo (mm/dia)' },
  // ...adicione outras se necessário
];